<template>
  <div class="c-buy-button__adimo-container">
    <div
      v-if="model.scriptType === 'productLightBox'"
      class="adimoWidget"
      data-type="lightbox"
      :data-default-language="model.defaultLanguage"
      :data-static-touchpoint-identifier="model.touchPointId"
      @click="trackButtonClick(model.touchPointId)"
    >
      <button
        class="c-buy-button"
        :class="model.buttonColorCssClass"
      >
        <!-- eslint-disable -->
        <span class="c-button-loader">
          <svg class="c-button-spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
          </svg>
        </span>
        <!-- eslint-enable -->
        <IconCart />
        <span>{{ model.text }}</span>
      </button>
    </div>
    <div
      v-if="model.scriptType === 'productPriceFirst'"
      class="adimo-site-product-first"
      data-type="site-product-first"
      :data-default-language="model.defaultLanguage"
      :data-static-touchpoint-identifier="model.touchPointId"
      @click="trackButtonClick(model.touchPointId)"
    >
      <button
        class="c-buy-button"
        :class="model.buttonColorCssClass"
      >
        <!-- eslint-disable -->
        <span class="c-button-loader">
          <svg class="c-button-spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
          </svg>
        </span>
        <!-- eslint-enable -->
        <IconCart />
        <span>{{ model.text }}</span>
      </button>
    </div>
    <div
      v-if="model.scriptType === 'recipeWidget'"
      class="adimo-container u-mb--s"
      data-type="recipe-widget"
      :data-touchpoint-id="model.touchPointId"
      :data-default-language="model.defaultLanguage"
      @click="trackButtonClick(model.touchPointId)"
    >
      <button
        class="c-buy-button"
        :class="model.buttonColorCssClass"
      >
        <!-- eslint-disable -->
        <span class="c-button-loader">
          <svg class="c-button-spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
          </svg>
        </span>
        <!-- eslint-enable -->
        <IconCart />
        <span>{{ model.text }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import IconCart from '@/assets/icons/icon-cart.svg'
import adimoLoader from '@/lib/adimo-loader'

export default {
  components: {
    IconCart
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  mounted() {
    adimoLoader.loadAdimo(this.model.scriptType)
  },
  methods: {
    trackButtonClick(id) {
      const trackingObj = {
        event: 'AdimoCtaButton',
        placement: this.model.tracking.placement,
        action: 'BuyNow ctaButton',
        touchpointId: id
      }
      if (this.model.tracking.productName) {
        trackingObj.productName = this.model.tracking.productName
      }
      window.dataLayer.push(trackingObj)
    }
  }
}
</script>
<style>
  .c-buy-button__adimo-container {
    display: flex;
    max-width: 100%;
  }
  .c-buy-button__adimo-container > div {
    max-width: 100%;
  }
  .c-buy-button__adimo-container .c-buy-button {
    border: 1px solid transparent;
    border-radius: 10px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 18px;
    line-height: 22px;
    padding: 17px 36px 13px;
    transition: background-color .3s cubic-bezier(0, 0, 0.2, 1);
    outline: none;
    max-width: 100%;
  }
  .c-buy-button__adimo-container .c-buy-button > svg {
    flex-shrink: 0;
    width: 21px;
    height: 18px;
    margin: 0 0 4px 0;
    margin-inline-end: 10px;
  }
  .c-buy-button__adimo-container .c-buy-button > span:not(.c-button-loader) {
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-secondary {
    background: #01396E;
    border-color: #01396E;
    color: white;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-secondary > svg,
  .c-buy-button__adimo-container .c-buy-button.btn-secondary .c-button-spinner .path {
    stroke: #fff;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-secondary:hover {
    background: #16213E;
    border-color: #16213E;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-primary {
    background: #FADE5F;
    border-color: #FADE5F;
    color: #16213E;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-primary > svg,
  .c-buy-button__adimo-container .c-buy-button.btn-primary .c-button-spinner .path{
    stroke: #16213E;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-primary:hover {
    background: #F7CD46;
    border-color: #F7CD46;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-white {
    background: #fff;
    border-color: #16213E;
    color: #16213E;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-white > svg,
  .c-buy-button__adimo-container .c-buy-button.btn-white .c-button-spinner .path{
    stroke: #16213E;
  }
  .c-buy-button__adimo-container .c-buy-button.btn-white:hover {
    background: #01396E1A;
    border-color: #16213E;
  }

  #header .c-buy-button__adimo-container .c-buy-button {
    font-size: 16px;
    padding: 9px 20px 6px;
  }
  @media screen and (max-width: 1279px) {
    #header .c-buy-button__adimo-container .c-buy-button {
      font-size: 22px;
      padding: 19px 30px 16px;
      margin-top: 24px;
      line-height: 29px;
    }
  }
  .c-promotional-block__item {
    display: flex;
    flex-direction: column;
  }
  .c-promotional-block__item > a {
    flex: 1;
  }
  .c-promotional-block__item .c-buy-button__adimo-container {
    padding-top: 10px;
  }
  .c-promotional-block__item .c-buy-button__adimo-container>div {
    width: 100%;
  }
  .c-promotional-block__item .c-buy-button__adimo-container .c-buy-button {
    font-size: 12px;
    padding: 13px 15px 10px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .swiper-slide > div > a {
    flex: 1;
  }
  .swiper-slide .c-buy-button__adimo-container {
    justify-content: center;
    padding-top: 20px;
  }
  .swiper-slide .c-buy-button__adimo-container .c-buy-button {
    font-size: 16px;
    padding: 16px 26px 12px;
  }
  .c-products-grid {
    display: flex;
    flex-direction: column;
  }
  .c-products-grid > a {
    flex: 1;
  }
  .c-products-grid .c-buy-button__adimo-container {
    justify-content: center;
    padding-top: 10px;
  }
  .c-products-grid .c-buy-button__adimo-container .c-buy-button {
    font-size: 16px;
    padding: 14px 26px 10px;
  }
  .c-button-loader {
    margin: -9px 12px -5px 0;
    display: none;
  }
  div[loading="true"] .c-button-loader {
    display: block;
  }
  div[loading="true"] .c-buy-button svg {
    display: none;
  }
  .adimoAjaxLoading .c-button-loader {
    display: block;
  }
  .adimoAjaxLoading .c-buy-button svg {
    display: none;
  }
  .c-button-spinner {
    display: block !important;
    animation: rotate 2s linear infinite;
    width: 19px;
    height: 19px;
  }

  .c-button-spinner .path {
    stroke: transparent;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
</style>
